var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#000018",
    fillOpacity: 0.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.022 16.626h-2.855v10.46h-4.325v-10.46h-2.058V12.95h2.058v-2.378c0-1.701.808-4.365 4.364-4.365l3.204.013v3.568h-2.325c-.381 0-.918.191-.918 1.002v2.164H20.4l-.378 3.672z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/facebook.eaa17f40.svg";
export { SvgFacebook as ReactComponent };